<template>
  <h1>Test2List</h1>
</template>

<script>
export default {
  name: "Test2List"
};
</script>

<style></style>
